import dayjs from "dayjs"
import { useMemo } from "react"
import { useGraphContext } from "../GraphContext"
import { useThisMinute } from "src/hooks"
import { round } from "src/utils"

export function useTimeDividers(start: string) {
  const {
    hoursPerDivider,
    hoursPerGraphItem,
  } = useGraphContext()

  const thisMinute = useThisMinute()

  return useMemo(
    () => {
      const dividers: string[] = []

      const startOfTomorrow = dayjs(start).startOf("day")
        .add(
          1,
          "day",
        )

      // the number of hours between end of day and start of graph item
      const diffInHours = Math.abs(startOfTomorrow.diff(
        start,
        "hours",
        true,
      ))
      const diffInDividers = diffInHours / hoursPerDivider

      const firstDividerTime = startOfTomorrow.subtract(
        diffInDividers * hoursPerDivider,
        "hours",
      )

      // the number of hours between graph start and the first time divider
      const firstDividerOffsetInHours = firstDividerTime.diff(
        start,
        "hours",
      )

      for (
        let i = firstDividerOffsetInHours;
        round(
          i,
          9,
        ) < hoursPerGraphItem;
        i += hoursPerDivider
      ) {
        const time = dayjs(start).add(
          i,
          "hours",
        )

        // only show dividers if they are before the current time
        if (dayjs(time).isBefore(thisMinute)) {
          dividers.push(time.toISOString())
        }
      }

      return dividers
    },
    [
      start,
      hoursPerDivider,
      hoursPerGraphItem,
      thisMinute,
    ],
  )
}
